import api from 'apis/config/api-service';

interface OtpParams {
  [key: string]: any;
}

export default {
  getOTPList: (params?: OtpParams) => api.get('/otp-code', { ...params }),
  getOTPById: (id: string | number) => api.get(`/otp-code/${id}`),
};
